<template>
  <div :class="className">
    <div
      id="continueModal"
      ref="continueModal"
      class="reveal"
      data-reveal
    >
      <div class="tender-confirm clearfix">
        <p class="msg_hint">
          {{ warnMessage || $t('warn.leave.lost') }}
        </p>
        <div class="tender-confirm-button-bar row align-right nav_btn">
          <button
            id="confirm_no"
            type="button"
            class="btn btn--darkblue"
            @click="cancelLeave()"
          >
            {{ $t('action.cancel') }}
          </button>
          <button
            id="confirm_yes"
            type="button"
            class="btn btn--orange"
            @click="continueTo()"
          >
            {{ $t('action.continue') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from '@/utils/eventBus'
import navigation from '@/utils/navigation'
import types from '@/store/mutation-types'
import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  name: 'ConfirmContinue',
  props: {
    className: {
      type: String,
      default: 'clearfix',
    },
  },

  data () {
    return {
      to: {},
      src: '',
      warnMessage: '',
      onContinue: null,
      onCancel: null,
    }
  },
  computed: {
    ...mapGetters('user', ['isEngineer']),
    ...mapGetters('workPermit', ['isUnderBatch']),
    ...mapGetters('form', {
      isDirty: 'isPageDirty',
      dirtyComponents: 'dirtyComponents',
    }),
  },
  mounted () {
    EventBus.$on('modules_confirm_continue_do_nav', ({to, src, message, onContinue, onCancel}) => {
      this.onContinue = onContinue || null
      this.onCancel = onCancel || null
      if (message) {
        this.warnMessage = message
        this.$nextTick(() => { this.doNav(to, src) })
      } else {
        this.doNav(to, src)
      }
    })
    EventBus.$on('modules_confirm_continue_close', (src) => {
      this.continueModal && this.continueModal.close()
      if (src) {
        this.setDirty({ src, isDirty: false })
        this.src = null
      } else {
        this.resetForm()
      }
      this.resetMessage()
      this.clearLeaveCallbacks()
    })
  },
  destroyed () {
    EventBus.$off('modules_confirm_continue_do_nav')
    EventBus.$off('modules_confirm_continue_close')
    if (this.continueModal) {
      this.continueModal.destroy()
    }
    $('#continueModal').remove()
  },
  methods: {
    ...mapActions('user', ['logout']),
    ...mapMutations('form', {
      setDirty: types.FORM_UPDATE,
      resetForm: types.RESET_STATE,
    }),
    ...mapMutations('workPermit', {
      setUnderBatch: types.WORKPERMIT_SET_UNDER_BATCH,
    }),
    resetMessage () {
      this.warnMessage = ''
    },
    clearLeaveCallbacks () {
      this.onContinue = null
      this.onCancel = null
    },
    async init () {
      if (!this.continueModal) {
        this.continueModal = await new Foundation.Reveal($('#continueModal'), {
          closeOnEsc: false,
          closeOnClick: false,
        })
      }
      $('#continueModal').parent().css('z-index', 9999)
    },
    closeModal () {
      this.resetMessage()
      this.clearLeaveCallbacks()
      this.continueModal.close()
    },
    cancelLeave () {
      const onCancel = this.onCancel
      this.resetMessage()
      this.clearLeaveCallbacks()
      this.continueModal.close()
      if (typeof onCancel === 'function') {
        onCancel()
      }
    },
    async doNav (to, src) {
      if (src && this.dirtyComponents[src]) {
        this.src = src
        await this.init()
        this.continueModal.open()
        return
      }
      if (this.isDirty || this.isUnderBatch || this.onContinue) {
        await this.init()
        this.to = to
        this.continueModal.open()
      } else {
        this.nav()
      }
    },
    continueTo () {
      const onContinue = this.onContinue
      this.resetMessage()
      this.clearLeaveCallbacks()
      this.continueModal.close()
      if (typeof onContinue === 'function') {
        onContinue()
        return
      }
      this.resetForm()
      if (this.isUnderBatch) {
        this.setUnderBatch(false)
        EventBus.emit('wp-review-ended')
      }
      if (this.src) {
        EventBus.$emit(`component_confirm_continue_${this.src}`)
        this.src = null
      } else {
        this.nav()
      }
    },
    nav () {
      if (this.to) {
        if (deep(this.to, 'params.action') === 'logout') {
          this.logout()
        } else {
          this.to.name
            ? this.$router.push({
              name: this.to.name,
              params: this.to.params,
              query: this.to.query,
            }) : this.$router.goBack()
        }
        this.to = {}
      } else {
        navigation.toHome()
      }
    },
  },
}
</script>

<style scoped lang="scss">
@import '~styles/popup';
#continueModal {
  width: 500px;
}
.msg_hint {
  font-weight: bold;
}
</style>
